import { InputTextType } from '../Enum/InputTextType';
import InputTextControl from './InputTextControl';
export default class InputNumberControl extends InputTextControl {
    constructor(field) {
        super(field);
        this.type = InputTextType.number;
    }
}
